import { withProps } from '@udecode/cn';
import {
    type CreatePlateEditorOptions,
    ParagraphPlugin,
    PlateElement,
    PlateLeaf,
    usePlateEditor,
} from '@udecode/plate/react';
import { BasicMarksPlugin, BoldPlugin, ItalicPlugin, StrikethroughPlugin, UnderlinePlugin } from '@udecode/plate-basic-marks/react';
import {
    MentionInputPlugin,
    MentionPlugin,
} from '@udecode/plate-mention/react';

import { MentionElement } from '../components/elements/mentionElement.component';
import { MentionInputElement } from '../components/elements/mentionInputElement.component';

export const basicNodesPlugins = [
    BasicMarksPlugin,
    MentionPlugin
] as const;

export const viewComponents = {
    [BoldPlugin.key]: withProps(PlateLeaf, { as: 'strong' }),
    [ItalicPlugin.key]: withProps(PlateLeaf, { as: 'em' }),
    [MentionPlugin.key]: MentionElement,
    [ParagraphPlugin.key]: withProps(PlateElement, {
        as: 'p',
        className: 'mb-4 leading-relaxed',
    }),
    [StrikethroughPlugin.key]: withProps(PlateLeaf, { as: 's' }),
    [UnderlinePlugin.key]: withProps(PlateLeaf, { as: 'u' }),
};

export const editorComponents = {
    ...viewComponents,
    [MentionInputPlugin.key]: MentionInputElement,
};

export const useCreateCommentsEditor = (
    {
        components,
        override,
        ...options
    }: {
    components?: Record<string, any>;
    plugins?: any[];
    readOnly?: boolean;
  } & Omit<CreatePlateEditorOptions, 'plugins'> = {},
    deps: any[] = []
) => {
    return usePlateEditor(
        {
            plugins: [
                ...basicNodesPlugins,
            ],
            override: {
                components: {
                    ...editorComponents,
                    ...components,
                },
                ...override,
            },
            ...options
        },
        deps
    );
};
